import { useEffect } from "react";
import { AppConfig } from "../config";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";

const PaypalTest = () => {

    useEffect(() => {
        // console.log(AppConfig.PAYPAL_CLIENT_ID);
    }, []);

    return (
        <PayPalScriptProvider options={{ "client-id": AppConfig.PAYPAL_CLIENT_ID, currency: 'USD', }}>
            <PayPalButtons
                createOrder={(data, actions) => {
                    return actions.order.create({
                            purchase_units: [
                                {
                                    amount: {
                                        currency_code: 'USD',
                                        value: '1000.99',
                                    },
                                },
                            ],
                        })
                        .then((orderId) => {
                            // Your code here after create the order
                            return orderId;
                        });
                }}                
                onApprove={(data, actions) => {
                    return actions.order.capture().then(details => {
                        const name = details.payer.name.given_name;
                        alert(`Transaction completed by ${name}`);
                    })
                }}
            ></PayPalButtons>
        </PayPalScriptProvider>
    )
}


export default PaypalTest;